var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-main page-btns" },
    [
      _c("div", { staticClass: "card_top" }, [_c("page-title")], 1),
      _vm._v(" "),
      _c("page-card", { staticClass: "no-padding", attrs: { noHead: true } }, [
        _c(
          "div",
          { staticClass: "page-table", attrs: { slot: "body" }, slot: "body" },
          [
            _c("div", { staticClass: "spaceBetween search-box" }, [
              _c("span", { staticClass: "search-title" }, [
                _vm._v("Volume details"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "spaceLeft search-form" },
                [
                  _c("search-month", {
                    ref: "datetime",
                    attrs: { label: "Date" },
                    on: {
                      valChange: function ($event) {
                        return _vm.valChange($event, "month")
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("search-select", {
                    ref: "Status",
                    attrs: { label: "Status", options: _vm.statusList },
                    on: {
                      valChange: function ($event) {
                        return _vm.valChange($event, "status")
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "3.2rem", "margin-left": "0.2rem" },
                      attrs: { placeholder: "Plase fill in" },
                      on: {
                        change: function ($event) {
                          return _vm.getList()
                        },
                      },
                      model: {
                        value: _vm.searchData.nickname,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchData, "nickname", $$v)
                        },
                        expression: "searchData.nickname",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { slot: "append", size: "mini" },
                          on: { click: _vm.getList },
                          slot: "append",
                        },
                        [
                          _c("svg-icon", {
                            attrs: { "icon-class": "tn-search" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.active == 1,
                        expression: "active == 1",
                      },
                    ],
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.tableData },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "nickname",
                        label: "Well Name",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "month", label: "Date", align: "center" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "type", label: "Type", align: "center" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "amount",
                        label: "My volume/m³",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "trustedAmount",
                        label: "Official volume/m³",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "deviation",
                        label: "Volume deviation ratio",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                "\n              " + _vm._s(row.deviation) + " "
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: row.deviation,
                                      expression: "row.deviation",
                                    },
                                  ],
                                },
                                [_vm._v("%")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "Deducted Expenses（UNIT）",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("NumberCom", {
                                attrs: { number: row.penaltyAmount },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "value",
                        label: "Value/$",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              row.rewardAmount > 0
                                ? _c(
                                    "span",
                                    [
                                      _c("NumberCom", {
                                        attrs: { number: row.rewardAmount },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "span",
                                    [
                                      _c("NumberCom", {
                                        attrs: { number: row.value },
                                      }),
                                    ],
                                    1
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Status", align: "left" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("img", {
                                staticStyle: { height: "0.3rem" },
                                attrs: {
                                  src: require("@/assets/image/volume/icon" +
                                    row.status +
                                    ".png"),
                                  alt: "",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Operation", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              row.status == 2
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleMintTAT(row)
                                        },
                                      },
                                    },
                                    [_vm._v("Mint Rep")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.active == 2,
                        expression: "active == 2",
                      },
                    ],
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.tableData },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "date", label: "Date", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm._f("time")(row.timestamp, "yyyy-MM-DD")
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "type", label: "Type", align: "center" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "produce",
                        label: "Block Height",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Value/$", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              row.status != 1
                                ? _c("span", [_vm._v("--")])
                                : _c("big-number", {
                                    attrs: { number: row.value },
                                  }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "deviation",
                        label: "Deducted Expenses（UNIT）",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("big-number", {
                                attrs: { number: row.deviation },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "status",
                        label: "Result",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              row.status == 1
                                ? _c("img", {
                                    staticStyle: { width: "1.24rem" },
                                    attrs: {
                                      src: require("../../assets/image/passed.png"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              row.status == 4
                                ? _c("img", {
                                    staticStyle: { width: "1.24rem" },
                                    attrs: {
                                      src: require("../../assets/image/notpass.png"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              row.status == 2
                                ? _c("img", {
                                    staticStyle: { width: "1.24rem" },
                                    attrs: {
                                      src: require("../../assets/image/inreview.png"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("pagination", {
                  attrs: {
                    total: _vm.total,
                    page: _vm.queryParams.page,
                    limit: _vm.queryParams.pageSize,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.queryParams, "page", $event)
                    },
                    "update:limit": function ($event) {
                      return _vm.$set(_vm.queryParams, "pageSize", $event)
                    },
                    pagination: function ($event) {
                      return _vm.getList()
                    },
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Upload digital assets",
            visible: _vm.open,
            width: "5rem",
          },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.form, "label-position": "top" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Block Height",
                    prop: "value",
                    rules: {
                      required: true,
                      message: "Please imput Block Height",
                    },
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        autocomplete: "off",
                        placeholder: "Please fill in",
                      },
                      model: {
                        value: _vm.form.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "value", $$v)
                        },
                        expression: "form.value",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100px" },
                          attrs: { slot: "prepend" },
                          slot: "prepend",
                          model: {
                            value: _vm.form.select,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "select", $$v)
                            },
                            expression: "form.select",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "BTC", value: "BTC" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "ETH", value: "ETH" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("No"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnLoading },
                  on: { click: _vm.handleSubmite },
                },
                [_vm._v("Submit")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Mint Rep",
            visible: _vm.mintRepDialogVisible,
            width: "7rem",
            "custom-class": "mint-rep-dialog",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.mintRepDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "mint-rep-content" }, [
            _c("div", { staticClass: "confirm-text" }, [
              _vm._v("\n        Confirm Mint Rep?\n      "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "add-wallet-section" }, [
              _c("div", { staticClass: "add-wallet-tip" }, [
                _vm._v("\n          Add to wallet before minting.\n          "),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "margin-left": "0.1rem",
                      color: "#3372EE",
                      cursor: "pointer",
                      "text-decoration": "underline",
                    },
                    on: { click: _vm.addRepTokenToWallet },
                  },
                  [_vm._v("Add to Wallet")]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.mintRepDialogVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.mintRepLoading },
                  on: { click: _vm.confirmMintRep },
                },
                [_vm._v("\n        Submit\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }